// @ts-nocheck
document.addEventListener("DOMContentLoaded", function () {
  const dropdowns = document.querySelectorAll(
    ".navbar-nav .dropdown, footer .dropdown",
  );

  dropdowns.forEach((dropdown) => {
    const link = dropdown.querySelector(".nav-link");
    link.addEventListener("click", function (e) {
      // Ensure the link works as expected
      window.location.href = this.href;
    });
  });

  // Add dropdown toggle buttons to menu items with children
  document
    .querySelectorAll(".navbar-nav .menu-item-has-children")
    .forEach((element) => {
      const button = document.createElement("button");
      button.type = "button";
      button.setAttribute("data-bs-toggle", "dropdown");
      button.setAttribute("aria-expanded", "false");
      button.classList.add("dropdown-toggle");
      element.appendChild(button);
    });

  // Mutation observer to handle dynamic changes
  const observer = new MutationObserver(() => {
    const navbarCollapse = document.querySelector(
      ".navbar-collapse.collapse.show",
    );

    if (navbarCollapse) {
      document
        .querySelectorAll(
          '.menu-item-has-children > a[data-bs-toggle="dropdown"]',
        )
        .forEach((anchor) => {
          anchor.removeAttribute("data-bs-toggle");
        });
    }
  });

  observer.observe(document.body, {
    attributes: true,
    childList: true,
    subtree: true,
  });

  // Handle navbar-collapse behavior on window resize
  window.addEventListener("resize", function () {
    const navbarCollapse = document.querySelector(".navbar-collapse");
    const navbarToggler = document.querySelector(".hamburger");

    // Close the navbar if it's open
    if (navbarCollapse && navbarCollapse.classList.contains("show")) {
      navbarToggler.click(); // Simulate a click to close the menu
    }
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const navbarCollapse = document.getElementById("navbarNav");

  navbarCollapse.addEventListener("show.bs.collapse", () => {
    document.body.classList.add("overflow-hidden");
  });

  navbarCollapse.addEventListener("hide.bs.collapse", () => {
    document.body.classList.remove("overflow-hidden");
  });
});
